/**
 * @generated SignedSource<<3aa43cffba3c07d6e02ba691c413595c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteNovaAgentInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteNovaAgentMutation$variables = {
  input: DeleteNovaAgentInput;
};
export type DeleteNovaAgentMutation$data = {
  readonly deleteNovaAgent: {
    readonly deletedNovaAgentId: string;
    readonly deletedVersionCount: number;
  } | null;
};
export type DeleteNovaAgentMutation = {
  variables: DeleteNovaAgentMutation$variables;
  response: DeleteNovaAgentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteNovaAgentPayload",
    "kind": "LinkedField",
    "name": "deleteNovaAgent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedNovaAgentId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedVersionCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteNovaAgentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteNovaAgentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c809c16e883cc2f621154744fda58b15",
    "id": null,
    "metadata": {},
    "name": "DeleteNovaAgentMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteNovaAgentMutation(\n  $input: DeleteNovaAgentInput!\n) {\n  deleteNovaAgent(input: $input) {\n    deletedNovaAgentId\n    deletedVersionCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "c16ffe717a53f6747e2c47a671b1c4f9";

export default node;
